@use "~theme/breakpoints";
@use "~theme/typography";

.bodyTextLarge {
  @include typography.body-large;
  color: var(--blue-01);

  margin-top: 0;
  margin-bottom: 6px;

  @include breakpoints.desktop {
    margin-top: 24px;
  }
}

.bodyText {
  @include typography.body;

  margin-left: 40px;
  margin-right: 40px;

  @include breakpoints.desktop {
    margin: 0;
  }
}

.caption {
  @include typography.caption;

  margin-top: 44px;
  text-align: left;
  margin-left: 16px;
  margin-right: 16px;
  padding-bottom: 66px;

  @include breakpoints.desktop {
    margin-top: 80px;
    margin-left: 0;
  }
}

.container {
  text-align: center;

  @include breakpoints.desktop {
    max-width: 840px;
    margin: 0 auto;
    text-align: left;
  }
}

.heading2 {
  color: var(--blue-01);

  @include typography.heading2;
}

.img {

  display: none;

  @include breakpoints.desktop {
    display: inline-block;
  }
}

.columns {
  display: flex;
  flex-direction: column;
  text-align: center;

  @include breakpoints.desktop {
    text-align: left;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr 100px 1fr;
    align-items: top;
    gap: 0;
  }
}

.centerColumn {
  margin-top: 24px;
  text-align: center;

  @include breakpoints.desktop {
    margin: 0;
    margin-top: 125px;
  }
}

.footerButtons {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  justify-content: center;

  @include breakpoints.desktop {
    flex-direction: row;
    align-items: center;
    max-width: 840px;
    margin: 0 auto;
    flex-grow: 1;
    gap: 24px;
  }
}

.or {
  color: var(--black-at-75);

  @include typography.heading4;
}

.top {

  margin-top: 12px;

  @include breakpoints.desktop {
    margin-top: 50px;
    margin-bottom: 40px;
  }
}

.skip {
  @include typography.link;

  margin-bottom: 28px;

  @include breakpoints.desktop {
    margin: 0;
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.captionLink {
  @include typography.caption-link;
}

.inlineLink {
  @include typography.body-link;
  border: none;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    border: none;
    color: var(--highlight-blue);
  }
}

.center {
  text-align: center;
}
